(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  const submitBtn = document.getElementById('submit');

  const contactEmail = document.getElementById('ContactForm-email');
  const contactPhone = document.getElementById('ContactForm-phone');

  contactEmail.addEventListener('click', function (e) {
    contactEmail.parentElement.parentElement.getElementsByClassName('contact__field-error')[0].style.display = 'none';
  });

  contactPhone.addEventListener('click', function (e) {
    contactPhone.parentElement.parentElement.getElementsByClassName('contact__field-error')[0].style.display = 'none';
  });

  submitBtn.addEventListener('click', function (e) {
    e.preventDefault();

    const contactEmailValue = document.getElementById('ContactForm-email').value;
    const contactEmailError = document.getElementById('ContactForm-email-error');
    const contactPhoneValue = document.getElementById('ContactForm-phone').value;
    const contactPhoneError = document.getElementById('ContactForm-phone-error');

    function isValidEmail(email) {
      // Checks format: text@text.text
      const pattern = /^[^@]+@[^@]+\.[^@]+$/;
      return pattern.test(email);
    }

    function isValidPhone(phone) {
      // Format: + followed by country code and digits
      const pattern = /^\+\d{6,15}$/;
      return pattern.test(phone);
    }

    if (!isValidEmail(contactEmailValue)) {
      contactEmailError.style.display = 'block';
    }

    if (!isValidPhone(contactPhoneValue)) {
      contactPhoneError.style.display = 'block';
    }

    if (isValidEmail(contactEmailValue) && isValidPhone(contactPhoneValue)) {
      const form = document.getElementById('ContactForm');
      form.requestSubmit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  var totalZone = document.getElementsByClassName('principal-cart__total')[0];
  var estimatedTotal = document.getElementsByClassName('item3')[0];

  if (totalZone && estimatedTotal) {
    totalZone.appendChild(estimatedTotal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  function extractMenu(element) {
    const menu = [];
    const domain = window.location.origin;

    function getDirectLink(li) {
      const firstChild = li.querySelector(':scope > a');
      return firstChild || null;
    }

    const items = element.children;

    for (let i = 0; i < items.length; i++) {
      const item = getDirectLink(items[i]);

      if (item == null) {
        var itemTextWithSubItems = items[i].getElementsByClassName('header__menu-item')[0].children[0].textContent;
        var itemContent = {
          text: itemTextWithSubItems,
          id: items[i].getElementsByClassName('header__menu-item')[0].children[0].dataset.url.includes(domain)
            ? items[i].getElementsByClassName('header__menu-item')[0].children[0].dataset.url
            : origin + '' + items[i].getElementsByClassName('header__menu-item')[0].children[0].dataset.url,
          children: []
        };

        var subItems = items[i].getElementsByClassName('mega-menu__list')[0].children;

        for (let j = 0; j < subItems.length; j++) {
          const subItem = getDirectLink(subItems[j]);

          const subItemContent = {
            text: subItem.textContent.replaceAll('  ', '').replaceAll('\n', ''),
            id: subItem.href.includes(origin) ? subItem.href : origin + '' + subItem.href,
            children: []
          };

          if (subItems[j].getElementsByClassName('list-unstyled')[0]) {
            const subSubItems = subItems[j].getElementsByClassName('list-unstyled')[0].children;

            for (let k = 0; k < subSubItems.length; k++) {
              const subSubItem = getDirectLink(subSubItems[k]);
              subItemContent.children.push({
                text: subSubItem.textContent.replaceAll('  ', '').replaceAll('\n', ''),
                id: subSubItem.href.includes(origin) ? subSubItem.href : origin + '' + subSubItem.href
              });
            }
          }

          itemContent.children.push(subItemContent);
        }

        menu.push(itemContent);
      } else {
        var itemContent = { text: item.textContent.replaceAll(' ', '').replaceAll('\n', ''), id: item.href };
        menu.push(itemContent);
      }
    }

    return menu;
  }

  function findBreadcrumb(data, collectionUrl) {
    let result = [];

    function traverse(nodes, path = []) {
      for (const node of nodes) {
        const currentPath = [...path, { text: node.text, url: node.id }];
        if (node.id === collectionUrl) {
          result = currentPath;
          return true;
        }
        if (node.children && traverse(node.children, currentPath)) {
          return true;
        }
      }
      return false;
    }

    traverse(data);
    return result;
  }

  function adaptToCurrentLang(targetUrl) {
    const currentLangMatch = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
    const currentLang = currentLangMatch ? currentLangMatch[1] : null;

    const url = new URL(targetUrl);

    // Extract possible language code from the target URL
    const targetLangMatch = url.pathname.match(/^\/([a-z]{2})(\/|$)/);
    const targetLang = targetLangMatch ? targetLangMatch[1] : null;

    let newPath = url.pathname;

    // Remove existing lang prefix from target path
    if (targetLang) {
      newPath = newPath.replace(/^\/[a-z]{2}(?=\/|$)/, '');
    }

    // Add current lang if it's not English
    if (currentLang && currentLang !== 'en') {
      newPath = `/${currentLang}${newPath}`;
    }

    url.pathname = newPath;

    return url.toString();
  }

  // Run the function on the main menu
  const navRoot = document.querySelector('nav.header__inline-menu > ul');
  const result = extractMenu(navRoot);

  breadcrumbsText = findBreadcrumb(result, window.location.href);

  if (breadcrumbsText.length > 0) {
    var liList = '';
    for (let i = 0; i < breadcrumbsText.length; i++) {
      liList += '<li><a href="' + breadcrumbsText[i].url + '">' + breadcrumbsText[i].text + '</a></li>';
      if (i != breadcrumbsText.length - 1) liList += '<li>|</li>';
    }
    document.getElementsByClassName('breadcrumbs')[0].innerHTML =
      '<ul class="non-native-breadcump" style="display: flex; gap: 8px; list-style: none; padding: 0; margin: 0;">' +
      liList +
      '</li></ul>';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const langSelect = document.getElementById('language-switcher');

    // Get path parts
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    let currentLang = 'en';

    // Detect if first segment is a 2-letter lang code
    if (pathParts.length > 0 && /^[a-z]{2}$/i.test(pathParts[0])) {
      currentLang = pathParts[0].toLowerCase();
    }

    // Set dropdown to detected lang
    langSelect.value = currentLang;

    // Handle language change
    langSelect.addEventListener('change', function () {
      const newLang = this.value;
      let newPathParts = [...pathParts];

      if (/^[a-z]{2}$/i.test(newPathParts[0])) {
        // Replace existing lang code
        if (newLang === 'en') {
          newPathParts.shift(); // remove lang if default is English
        } else {
          newPathParts[0] = newLang;
        }
      } else {
        // No lang in URL
        if (newLang !== 'en') {
          newPathParts.unshift(newLang);
        }
      }

      // Build new URL
      const newUrl = '/' + newPathParts.join('/') + window.location.search + window.location.hash;
      window.location.href = newUrl;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  let priceSale = document.getElementsByClassName('price__sale')[0];
  if (priceSale) priceSale.innerHTML += '<span>HT</span>';

  function extractMenu(element) {
    const menu = [];
    const domain = window.location.origin;

    function getDirectLink(li) {
      const firstChild = li.querySelector(':scope > a');
      return firstChild || null;
    }

    const items = element.children;

    for (let i = 0; i < items.length; i++) {
      const item = getDirectLink(items[i]);

      if (item == null) {
        var itemTextWithSubItems = items[i].getElementsByClassName('header__menu-item')[0].children[0].textContent;
        var itemContent = {
          text: itemTextWithSubItems,
          id: items[i].getElementsByClassName('header__menu-item')[0].children[0].dataset.url.includes(domain)
            ? items[i].getElementsByClassName('header__menu-item')[0].children[0].dataset.url
            : origin + '' + items[i].getElementsByClassName('header__menu-item')[0].children[0].dataset.url,
          children: [],
        };

        var subItems = items[i].getElementsByClassName('mega-menu__list')[0].children;

        for (let j = 0; j < subItems.length; j++) {
          const subItem = getDirectLink(subItems[j]);

          const subItemContent = {
            text: subItem.textContent.replaceAll('  ', '').replaceAll('\n', ''),
            id: subItem.href.includes(origin) ? subItem.href : origin + '' + subItem.href,
            children: [],
          };

          if (subItems[j].getElementsByClassName('list-unstyled')[0]) {
            const subSubItems = subItems[j].getElementsByClassName('list-unstyled')[0].children;

            for (let k = 0; k < subSubItems.length; k++) {
              const subSubItem = getDirectLink(subSubItems[k]);
              subItemContent.children.push({
                text: subSubItem.textContent.replaceAll('  ', '').replaceAll('\n', ''),
                id: subSubItem.href.includes(origin) ? subSubItem.href : origin + '' + subSubItem.href,
              });
            }
          }

          itemContent.children.push(subItemContent);
        }

        menu.push(itemContent);
      } else {
        var itemContent = { text: item.textContent.replaceAll(' ', '').replaceAll('\n', ''), id: item.href };
        menu.push(itemContent);
      }
    }

    return menu;
  }

  function findBreadcrumb(data, collectionUrl) {
    let result = [];

    function traverse(nodes, path = []) {
      for (const node of nodes) {
        const currentPath = [...path, { text: node.text, url: node.id }];
        if (node.id === collectionUrl) {
          result = currentPath;
          return true;
        }
        if (node.children && traverse(node.children, currentPath)) {
          return true;
        }
      }
      return false;
    }

    traverse(data);
    return result;
  }

  function adaptToCurrentLang(targetUrl) {
    const currentLangMatch = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
    const currentLang = currentLangMatch ? currentLangMatch[1] : null;

    const url = new URL(targetUrl);

    // Extract possible language code from the target URL
    const targetLangMatch = url.pathname.match(/^\/([a-z]{2})(\/|$)/);
    const targetLang = targetLangMatch ? targetLangMatch[1] : null;

    let newPath = url.pathname;

    // Remove existing lang prefix from target path
    if (targetLang) {
      newPath = newPath.replace(/^\/[a-z]{2}(?=\/|$)/, '');
    }

    // Add current lang if it's not English
    if (currentLang && currentLang !== 'en') {
      newPath = `/${currentLang}${newPath}`;
    }

    url.pathname = newPath;

    return url.toString();
  }

  // Run the function on the main menu
  const navRoot = document.querySelector('nav.header__inline-menu > ul');
  const result = extractMenu(navRoot);

  const lastPageUrl = localStorage.getItem('lastPageUrl');
  let breadcrumbsoriginLS = localStorage.getItem('breadcrumbsorigin');
  let isBreadcumpNativeLS = localStorage.getItem('isBreadcumpNative');

  let isBreadcumpNative = '1';

  // alert(isBreadcumpNativeLS);
  breadcrumbsoriginLS = adaptToCurrentLang(breadcrumbsoriginLS ? breadcrumbsoriginLS : window.location.href);

  if (
    lastPageUrl.includes('/collections/') ||
    (lastPageUrl.includes('/products/') && breadcrumbsoriginLS && isBreadcumpNativeLS == '0')
  ) {
    var breadcrumbsText = findBreadcrumb(
      result,
      lastPageUrl.includes('/collections/') ? lastPageUrl : breadcrumbsoriginLS
    );

    if (breadcrumbsText.length > 0) {
      var liList = '';
      for (let i = 0; i < breadcrumbsText.length; i++) {
        liList += '<li><a href="' + breadcrumbsText[i].url + '">' + breadcrumbsText[i].text + '</a></li><li>|</li>';
      }
      document.getElementsByClassName('breadcrumbs')[0].innerHTML =
        '<ul class="non-native-breadcump" style="display: flex; gap: 8px; list-style: none; padding: 0; margin: 0;">' +
        liList +
        '<li><strong>' +
        document.getElementsByClassName('product-title-label')[0].textContent +
        '</strong></li></ul>';
    }

    const breadcrumbsorigin = lastPageUrl.includes('/collections/') ? lastPageUrl : breadcrumbsoriginLS;

    setTimeout(function () {
      isBreadcumpNative = '0';

      localStorage.setItem('breadcrumbsorigin', breadcrumbsorigin);
      localStorage.setItem('isBreadcumpNative', isBreadcumpNative);
    }, 1000);
  } else {
    isBreadcumpNative = '1';
    localStorage.setItem('isBreadcumpNative', isBreadcumpNative);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  let badges = document.getElementsByClassName('badge');
  hidePageBadges(badges);

  function hidePageBadges(badges) {
    for (let i = 0; i < badges.length; i++) {
      if (badges[i].textContent.includes('Page')) badges[i].parentElement.style.display = 'none';
    }
  }

  } catch(e) { console.error(e); }
})();
})();
